import React from 'react';
import { useGtXs } from '../../../hooks/useGtXs';
import { range } from '../../../services/Utils';
import Typography from '../../Typography/Typography';
import styles from './Separator.module.scss';

interface SeparatorProps {
    title: string;
}

export default function Separator(props: SeparatorProps) {
    const { title } = props;
    const gtXs = useGtXs();
    const stars = gtXs ? 4 : 2;
    const variant = gtXs ? "ColisseumRegular58" : "ColisseumRegular34";

    return (
        <div className={styles.Separator}>
            <div className={styles.Line}></div>
            <div className={styles.Line}></div>
            <div className={styles.StarContainer}>
                <div className={`${styles.StarsGroup} ${styles.Left}`}>
                    {range(1, stars).map((i) =>
                        <span key={`star-left-${i}`} className={styles.Star} />
                    )}
                </div>
                <Typography variant={variant} className={styles.Title}>
                    {title}
                </Typography>
                <div className={`${styles.StarsGroup} ${styles.Right}`}>
                    {range(1, stars).map((i) =>
                        <span key={`star-right-${i}`} className={styles.Star} />
                    )}
                </div>
            </div>
            <div className={styles.Line}></div>
            <div className={styles.Line}></div>
        </div>
    );
}
